import { ListItemButton, styled } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, type JSX } from 'react';

interface Props {
  content: JSX.Element;
  'data-testid'?: string;
  href?: string;
  sx?: SxProps;
  deleted?: boolean;
}

const StyledResultsDetailCardButton = styled(ListItemButton)<{ deleted: boolean; hasLink: boolean }>(({ deleted, hasLink }) => ({
  alignItems: 'start',
  color: 'inherit',
  cursor: hasLink ? 'pointer' : 'default',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  width: '100%',
  textDecoration: deleted ? 'line-through!important' : 'none',
}));

export const ResultsDetailCard: FC<Props> = ({ content, href, sx, deleted = false, ...props }) => {
  const hasLink = href !== undefined;
  const handleClick = (): void => {
    if (href) {
      window.location.assign(href);
    }
  };

  return (
    <Box sx={sx}>
      <StyledResultsDetailCardButton
        data-testid={props['data-testid']}
        role="button"
        onClick={handleClick}
        disableRipple={!hasLink}
        deleted={deleted}
        hasLink={hasLink}
      >
        {content}
      </StyledResultsDetailCardButton>
    </Box>
  );
};
